module.exports = __webpack_public_path__ + "img/service_msg.d38330eb.png";